import { gql } from '@apollo/client';

export const SUGGEST_USERNAMES = gql`
  query SuggestUsernames($input: SuggestUsernameInput!) {
    suggestUsernames(input: $input) {
      suggestions
    }
  }
`;

export const CHECK_USERNAME_AVAILABILITY = gql`
  query CheckUsernameAvailability($input: CheckUsernameAvailabilityInput!) {
    checkUsernameAvailability(input: $input) {
      isAvailable
    }
  }
`;

export const CHECK_EMAIL_AVAILABILITY = gql`
  query CheckEmailAvailability($input: CheckEmailAvailabilityInput!) {
    checkEmailAvailability(input: $input) {
      isAvailable
    }
  }
`;
